import React from 'react';

import { Button } from './index';
import cardLinkType from '../../lib/utils/card-link-type';

import * as styles from './index.module.scss';

const ButtonsRow = ({ links, buttonsStyle, type, activeSlug }) => {

    return (
        <div className={`${styles.buttonContainer} ${!type && buttonsStyle === "flow" && styles.flowButton} ${type && styles.categoryButton}`}>
            {links && links.map((link, index) => {

                if(link?.node) {
                    return(
                        <Button
                            additionalClasses={link.node.slug === activeSlug && styles.activeButton}
                            key={`buttons-${index}`}
                            href={`${cardLinkType(type) + link.node.slug}`}
                            content={link.node.title}
                            alt={link.node.title}
                            fullWidth={true}
                        />
                    )
                }else{
                    return(
                        <Button
                            additionalClasses={link.url === activeSlug && styles.activeButton}
                            key={`buttons-${index}`}
                            id={link.id}
                            elementType={link.elementType}
                            colorData={link.colorData}
                            typeData={link.typeData}
                            href={link.url}
                            content={link.text}
                            alt={link.alt}
                            fullWidth={buttonsStyle === "flow" ? false : true}
                        />
                    )
                }
            })}
        </div>
    );
};

export default ButtonsRow;